<template>

    <div class="content-load">

        <Top></Top>
        <!-- Dashboard Container -->
        <div class="dashboard-container">

            <Sidebar></Sidebar>

            <!-- Dashboard Content
            ================================================== -->
            <div class="dashboard-content-container">
                <div class="dashboard-content-inner" >

                    <!-- Dashboard Headline -->
                    <div class="dashboard-headline hidden-xs">
                        <h3>
                            {{$router.currentRoute.meta.title}}
                        </h3>
                    </div>
                        
                    <!-- Row -->
                    <div class="row">          
                        <div class="col-lg-6 col-xs-12 col-xl-6 col-md-12">
                            <p class="page-text margin-bottom-15">
                                Gerencie abaixo as configurações globais do aplicativo.
                            </p>
                        </div>                                 
                        <div class="col-xl-12 margin-bottom-20 menu">
                            
                            <a class="button block-mobile small" v-on:click="setTab('lembrete-agendamento')" v-bind:class="{'transparent': tab != 'lembrete-agendamento', 'color-primary': tab == 'lembrete-agendamento'}">
                                <i class="las la-calendar"></i>
                                Lembrete de agendamento
                            </a>

                            <a class="button block-mobile small" v-on:click="setTab('confirmacao-agendamento')" v-bind:class="{'transparent': tab != 'confirmacao-agendamento', 'color-primary': tab == 'confirmacao-agendamento'}">
                                <i class="las la-calendar-check"></i>
                                Confirmação de agendamento
                            </a>

                            <a class="button block-mobile small" v-on:click="setTab('feedback')" v-bind:class="{'transparent': tab != 'feedback', 'color-primary': tab == 'feedback'}">
                                <i class="las la-thumbs-up"></i>
                                Avaliações / Recomendações
                            </a>

                            <a class="button block-mobile small" v-on:click="setTab('sintomas')" v-bind:class="{'transparent': tab != 'sintomas', 'color-primary': tab == 'sintomas'}">
                                <i class="las la-clipboard-list"></i>
                                Editar Popup de sintomas
                            </a>

                            <a class="button block-mobile small" v-on:click="setTab('politicas-de-privacidade')" v-bind:class="{'transparent': tab != 'politicas-de-privacidade', 'color-primary': tab == 'politicas-de-privacidade'}">
                                <i class="las la-file-alt"></i>
                                Editar políticas de privacidade
                            </a>

                            <a class="button block-mobile small" v-on:click="setTab('termos-de-uso')" v-bind:class="{'transparent': tab != 'termos-de-uso', 'color-primary': tab == 'termos-de-uso'}">
                                <i class="las la-file-alt"></i>
                                Editar termos de uso
                            </a>

                            <a class="button block-mobile small" v-on:click="setTab('solicitar-uso-de-dados')" v-bind:class="{'transparent': tab != 'solicitar-uso-de-dados', 'color-primary': tab == 'solicitar-uso-de-dados'}">
                                <i class="las la-lock"></i>
                                Solicitar uso de dados
                            </a>

                            <a class="button block-mobile small" v-on:click="setTab('menu')" v-bind:class="{'transparent': tab != 'menu', 'color-primary': tab == 'menu'}">
                                <i class="las la-bars"></i>
                                Itens do menu
                            </a>

                            <a class="button block-mobile small" v-on:click="setTab('prontuario')" v-bind:class="{'transparent': tab != 'prontuario', 'color-primary': tab == 'prontuario'}">
                                <i class="las la-cog"></i>
                                Opções do prontuário
                            </a>                            

                            <a class="button block-mobile small" v-on:click="$root.go('Logs')">
                                <i class="las la-list"></i>
                                Logs de acesso
                            </a>

                            <a class="button block-mobile small" v-on:click="setTab('filtro-campanha')" v-bind:class="{'transparent': tab != 'filtro-campanha', 'color-primary': tab == 'filtro-campanha'}">
                                <i class="las la-code"></i>
                                Filtros de campanhas
                            </a>    

                            <a class="button block-mobile small" v-on:click="setTab('honorarios-medicos')" v-bind:class="{'transparent': tab != 'honorarios-medicos', 'color-primary': tab == 'honorarios-medicos'}">
                                <i class="las la-file-invoice-dollar"></i>
                                Honorários médicos
                            </a>                    

                            <a class="button block-mobile small" v-on:click="$root.go('Areas')">
                                <i class="las la-users"></i>
                                Áreas de usuários
                            </a>                                                                    

                        </div>  

                        <div class="col-xl-12 scroll-to"></div>

                        <div class="col-xl-12 margin-top-10" v-show="tab == 'lembrete-agendamento'">
                            <hr>
                            <form type="post" v-on:submit.prevent="salvar()">
                                <div class="row">
                                    <div class="col-xl-12 margin-bottom-15 margin-top-10">
                                        <h3>
                                            <i class="las la-calendar"></i>
                                            Lembrete de agendamento
                                        </h3>
                                    </div>
                                    <div class="col-xl-12 col-xs-12 col-lg-12">
                                        <div class="row">
                                            <div class="col-xl-6 col-md-6 col-lg-10 margin-top-10">
                                                <div class="submit-field">
                                                    <h5>Enviar quantas horas antes?</h5>
                                                    <input style="width: 90px;" type="number" placeholder="..." class="with-border" v-model="form['lembrete-agendamento'].objeto.tempo">
                                                </div>
                                            </div>
                                            <div class="col-xl-12"></div>
                                            <div class="col-xl-6 col-md-6 col-lg-10">
                                                <div class="submit-field">
                                                    <h5>Onde será enviado</h5>
                                                    <div class="checkbox">
                                                        <input type="checkbox" id="lembrete-agendamento-sms" true-value="1" false-value="0" v-model="form['lembrete-agendamento'].objeto.smsEnviar">
                                                        <label for="lembrete-agendamento-sms"><span class="checkbox-icon"></span> SMS</label>
                                                    </div>
                                                    <br>
                                                    <div class="checkbox">
                                                        <input type="checkbox" id="lembrete-agendamento-email" true-value="1" false-value="0" v-model="form['lembrete-agendamento'].objeto.emailEnviar">
                                                        <label for="lembrete-agendamento-email"><span class="checkbox-icon"></span> E-mail</label>
                                                    </div>
                                                    <br>
                                                    <div class="checkbox">
                                                        <input type="checkbox" id="lembrete-agendamento-whatsapp" true-value="1" false-value="0" v-model="form['lembrete-agendamento'].objeto.whatsappEnviar">
                                                        <label for="lembrete-agendamento-whatsapp"><span class="checkbox-icon"></span> WhatsApp</label>
                                                    </div>
                                                    <br>
                                                    <div class="checkbox">
                                                        <input type="checkbox" id="lembrete-agendamento-push" true-value="1" false-value="0" v-model="form['lembrete-agendamento'].objeto.pushEnviar">
                                                        <label for="lembrete-agendamento-push"><span class="checkbox-icon"></span> Notificação push</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-xl-12"></div>

                                            <div v-show="form['lembrete-agendamento'].objeto.smsEnviar == 1" class="col-xl-12 margin-bottom-25">
                                                <hr>
                                                <h3>
                                                    <i class="las la-info-circle"></i>
                                                    SMS
                                                </h3>
                                            </div>

                                            <div v-show="form['lembrete-agendamento'].objeto.smsEnviar == 1" class="col-xl-12 col-md-12 col-lg-12">
                                                <div class="submit-field">
                                                    <h5>Texto que será enviado via SMS</h5>
                                                    <textarea placeholder="..." class="with-border" v-model="form['lembrete-agendamento'].objeto.smsTexto" style="min-height: 70px;"></textarea>
                                                </div>
                                            </div>
                                            <div class="col-xl-12"></div>

                                            <div v-show="form['lembrete-agendamento'].objeto.emailEnviar == 1" class="col-xl-12 margin-bottom-25">
                                                <hr>
                                                <h3>
                                                    <i class="las la-info-circle"></i>
                                                    E-mail
                                                </h3>
                                            </div>
                                            <div v-show="form['lembrete-agendamento'].objeto.emailEnviar == 1" class="col-xl-6 col-md-6 col-lg-10">
                                                <div class="submit-field">
                                                    <h5>Assunto do e-mail</h5>
                                                    <input type="text" placeholder="..." class="with-border" v-model="form['lembrete-agendamento'].objeto.emailAssunto">
                                                </div>
                                            </div>

                                            <div v-show="form['lembrete-agendamento'].objeto.emailEnviar == 1" class="col-xl-6 col-md-6 col-lg-10">
                                                <div class="submit-field">
                                                    <h5>Título do e-mail</h5>
                                                    <input type="text" placeholder="..." class="with-border" v-model="form['lembrete-agendamento'].objeto.emailTitulo">
                                                </div>
                                            </div>                                            

                                            <div v-show="form['lembrete-agendamento'].objeto.emailEnviar == 1" class="col-xl-12 col-md-12 col-lg-12">
                                                <div class="submit-field">
                                                    <h5>Texto do e-mail</h5>
                                                    <trumbowyg v-model="form['lembrete-agendamento'].objeto.emailTexto" :config="config" style="height: 400px;" class="" name="lembreteAgendamentoEmailTexto"></trumbowyg>
                                                    <!-- <textarea placeholder="..." class="with-border" style="min-height: 100px;" v-model="form['lembrete-agendamento'].objeto.emailTexto"></textarea> -->
                                                </div>
                                            </div>

                                            <div v-show="form['lembrete-agendamento'].objeto.whatsappEnviar == 1" class="col-xl-12 margin-bottom-25">
                                                <hr>
                                                <h3>
                                                    <i class="las la-info-circle"></i>
                                                    WhatsApp
                                                </h3>
                                            </div>

                                            <div v-show="form['lembrete-agendamento'].objeto.whatsappEnviar == 1" class="col-xl-12 col-md-12 col-lg-12">
                                                <div class="submit-field">
                                                    <h5>Texto da mensagem a ser enviada via WhatsApp</h5>
                                                    <textarea placeholder="..." class="with-border" style="min-height: 180px;" v-model="form['lembrete-agendamento'].objeto.whatsappTexto"></textarea>
                                                </div>
                                            </div>                                            
                                            <div class="col-xl-12"></div>
                                            <div v-show="form['lembrete-agendamento'].objeto.pushEnviar == 1" class="col-xl-12 margin-bottom-25">
                                                <hr>
                                                <h3>
                                                    <i class="las la-info-circle"></i>
                                                    Notificação push
                                                </h3>
                                            </div>
                                            <div v-show="form['lembrete-agendamento'].objeto.pushEnviar == 1" class="col-xl-6 col-md-6 col-lg-10">
                                                <div class="submit-field">
                                                    <h5>Título da notificação</h5>
                                                    <input type="text" placeholder="..." v-model="form['lembrete-agendamento'].objeto.pushTitulo" class="with-border">
                                                </div>
                                            </div>
<!--                                             <div v-show="form['lembrete-agendamento'].objeto.pushEnviar == 1" class="col-xl-6 col-md-6 col-lg-10">
                                                <div class="submit-field">
                                                    <h5>Link (opcional)</h5>
                                                    <input type="text" placeholder="..." v-model="form['lembrete-agendamento'].objeto.pushLink" class="with-border">
                                                </div>
                                            </div> -->
                                            <div v-show="form['lembrete-agendamento'].objeto.pushEnviar == 1" class="col-xl-12 col-md-12 col-lg-12 col-xs-12">
                                                <div class="submit-field">
                                                    <h5>Texto da notificação</h5>
                                                    <textarea placeholder="..." class="with-border" v-model="form['lembrete-agendamento'].objeto.pushTexto" style="min-height: 180px;"></textarea>
                                                </div>
                                            </div>        


                                            <!-- Button -->
                                            <div class="col-xl-12 margin-bottom-20">
                                                <button type="submit" class="button green block-mobile">
                                                    <i class="las la-save"></i>
                                                    Salvar alterações
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div> 

                        <div class="col-xl-12 margin-top-10" v-show="tab == 'confirmacao-agendamento'">
                            <hr>
                            <form type="post" v-on:submit.prevent="salvar()">
                                <div class="row">
                                    <div class="col-xl-12 margin-bottom-15 margin-top-10">
                                        <h3>
                                            <i class="las la-calendar-check"></i>                                    
                                            Confirmação de agendamento
                                        </h3>
                                    </div>
                                    <div class="col-xl-12 col-xs-12 col-lg-12">
                                        <div class="row">
                                            <div class="col-xl-6 col-md-6 col-lg-10 margin-top-10">
                                                <div class="submit-field">
                                                    <h5>Enviar quantos dias antes?</h5>
                                                    <input style="width: 90px;" type="number" placeholder="..." class="with-border" v-model="form['confirmacao-agendamento'].objeto.tempo">
                                                </div>
                                            </div>
                                            <div class="col-xl-12"></div>
                                            <div class="col-xl-6 col-md-6 col-lg-10">
                                                <div class="submit-field">
                                                    <h5>Onde será enviado</h5>
                                                    <div class="checkbox">
                                                        <input type="checkbox" id="confirmacao-agendamento-sms" true-value="1" false-value="0" v-model="form['confirmacao-agendamento'].objeto.smsEnviar">
                                                        <label for="confirmacao-agendamento-sms"><span class="checkbox-icon"></span> SMS</label>
                                                    </div>
                                                    <br>
                                                    <div class="checkbox">
                                                        <input type="checkbox" id="confirmacao-agendamento-email" true-value="1" false-value="0" v-model="form['confirmacao-agendamento'].objeto.emailEnviar">
                                                        <label for="confirmacao-agendamento-email"><span class="checkbox-icon"></span> E-mail</label>
                                                    </div>
                                                    <br>
                                                    <div class="checkbox">
                                                        <input type="checkbox" id="confirmacao-agendamento-whatsapp" true-value="1" false-value="0" v-model="form['confirmacao-agendamento'].objeto.whatsappEnviar">
                                                        <label for="confirmacao-agendamento-whatsapp"><span class="checkbox-icon"></span> WhatsApp</label>
                                                    </div>
                                                    <br>
                                                    <div class="checkbox">
                                                        <input type="checkbox" id="confirmacao-agendamento-push" true-value="1" false-value="0" v-model="form['confirmacao-agendamento'].objeto.pushEnviar">
                                                        <label for="confirmacao-agendamento-push"><span class="checkbox-icon"></span> Notificação push</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-xl-12"></div>

                                            <div v-show="form['confirmacao-agendamento'].objeto.smsEnviar == 1" class="col-xl-12 margin-bottom-25">
                                                <hr>
                                                <h3>
                                                    <i class="las la-info-circle"></i>
                                                    SMS
                                                </h3>
                                            </div>

                                            <div v-show="form['confirmacao-agendamento'].objeto.smsEnviar == 1" class="col-xl-12 col-md-12 col-lg-12">
                                                <div class="submit-field">
                                                    <h5>Texto que será enviado via SMS</h5>
                                                    <textarea placeholder="..." class="with-border" v-model="form['confirmacao-agendamento'].objeto.smsTexto" style="min-height: 70px;"></textarea>
                                                </div>
                                            </div>
                                            <div class="col-xl-12"></div>

                                            <div v-show="form['confirmacao-agendamento'].objeto.emailEnviar == 1" class="col-xl-12 margin-bottom-25">
                                                <hr>
                                                <h3>
                                                    <i class="las la-info-circle"></i>
                                                    E-mail
                                                </h3>
                                            </div>
                                            <div v-show="form['confirmacao-agendamento'].objeto.emailEnviar == 1" class="col-xl-6 col-md-6 col-lg-10">
                                                <div class="submit-field">
                                                    <h5>Assunto do e-mail</h5>
                                                    <input type="text" placeholder="..." class="with-border" v-model="form['confirmacao-agendamento'].objeto.emailAssunto">
                                                </div>
                                            </div>

                                            <div v-show="form['confirmacao-agendamento'].objeto.emailEnviar == 1" class="col-xl-6 col-md-6 col-lg-10">
                                                <div class="submit-field">
                                                    <h5>Título do e-mail</h5>
                                                    <input type="text" placeholder="..." class="with-border" v-model="form['confirmacao-agendamento'].objeto.emailTitulo">
                                                </div>
                                            </div>                                            

                                            <div v-show="form['confirmacao-agendamento'].objeto.emailEnviar == 1" class="col-xl-12 col-md-12 col-lg-12">
                                                <div class="submit-field">
                                                    <h5>Texto do e-mail</h5>
                                                    <trumbowyg v-model="form['confirmacao-agendamento'].objeto.emailTexto" :config="config" style="height: 400px;" class="" name="confirmacaoAgendamentoEmailTexto"></trumbowyg>
                                                    <!-- <textarea placeholder="..." class="with-border" style="min-height: 100px;" v-model="form['confirmacao-agendamento'].objeto.emailTexto"></textarea> -->
                                                </div>
                                            </div>

                                            <div v-show="form['confirmacao-agendamento'].objeto.whatsappEnviar == 1" class="col-xl-12 margin-bottom-25">
                                                <hr>
                                                <h3>
                                                    <i class="las la-info-circle"></i>
                                                    WhatsApp
                                                </h3>
                                            </div>

                                            <div v-show="form['confirmacao-agendamento'].objeto.whatsappEnviar == 1" class="col-xl-12 col-md-12 col-lg-12">
                                                <div class="submit-field">
                                                    <h5>Texto da mensagem a ser enviada via WhatsApp</h5>
                                                    <textarea placeholder="..." class="with-border" style="min-height: 180px;" v-model="form['confirmacao-agendamento'].objeto.whatsappTexto"></textarea>
                                                </div>
                                            </div>                                            
                                            <div class="col-xl-12"></div>
                                            <div v-show="form['confirmacao-agendamento'].objeto.pushEnviar == 1" class="col-xl-12 margin-bottom-25">
                                                <hr>
                                                <h3>
                                                    <i class="las la-info-circle"></i>
                                                    Notificação push
                                                </h3>
                                            </div>
                                            <div v-show="form['confirmacao-agendamento'].objeto.pushEnviar == 1" class="col-xl-6 col-md-6 col-lg-10">
                                                <div class="submit-field">
                                                    <h5>Título da notificação</h5>
                                                    <input type="text" placeholder="..." v-model="form['confirmacao-agendamento'].objeto.pushTitulo" class="with-border">
                                                </div>
                                            </div>
<!--                                             <div v-show="form['confirmacao-agendamento'].objeto.pushEnviar == 1" class="col-xl-6 col-md-6 col-lg-10">
                                                <div class="submit-field">
                                                    <h5>Link (opcional)</h5>
                                                    <input type="text" placeholder="..." v-model="form['confirmacao-agendamento'].objeto.pushLink" class="with-border">
                                                </div>
                                            </div> -->
                                            <div v-show="form['confirmacao-agendamento'].objeto.pushEnviar == 1" class="col-xl-12 col-md-12 col-lg-12 col-xs-12">
                                                <div class="submit-field">
                                                    <h5>Texto da notificação</h5>
                                                    <textarea placeholder="..." class="with-border" v-model="form['confirmacao-agendamento'].objeto.pushTexto" style="min-height: 180px;"></textarea>
                                                </div>
                                            </div>    

                                            <!-- Button -->
                                            <div class="col-xl-12 margin-bottom-20">
                                                <button type="submit" class="button green block-mobile">
                                                    <i class="las la-save"></i>
                                                    Salvar alterações
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>                            
                        </div>  
<!-- 
                        <div class="col-xl-12 margin-top-10" v-show="tab == 'lembrete-retorno-agendamento'">
                            <hr>
                            <form type="post" v-on:submit.prevent="salvar()">
                                <div class="row">
                                    <div class="col-xl-12 margin-bottom-15 margin-top-10">
                                        <h3>
                                            <i class="material-icons">redo</i>                                    
                                            Lembrete para agendar retorno
                                        </h3>
                                    </div>
                                    <div class="col-xl-12 col-xs-12 col-lg-12">
                                        <div class="row">
                                            <div class="col-xl-6 col-md-6 col-lg-10 margin-top-10">
                                                <div class="submit-field">
                                                    <h5>Enviar depois de quantos dias?</h5>
                                                    <input style="width: 90px;" type="number" placeholder="..." class="with-border" v-model="form['lembrete-retorno-agendamento'].objeto.tempo">
                                                </div>
                                            </div>
                                            <div class="col-xl-12"></div>
                                            <div class="col-xl-6 col-md-6 col-lg-10">
                                                <div class="submit-field">
                                                    <h5>Onde será enviado</h5>
                                                    <div class="checkbox">
                                                        <input type="checkbox" id="lembrete-retorno-agendamento-sms" true-value="1" false-value="0" v-model="form['lembrete-retorno-agendamento'].objeto.smsEnviar">
                                                        <label for="lembrete-retorno-agendamento-sms"><span class="checkbox-icon"></span> SMS</label>
                                                    </div>
                                                    <br>
                                                    <div class="checkbox">
                                                        <input type="checkbox" id="lembrete-retorno-agendamento-email" true-value="1" false-value="0" v-model="form['lembrete-retorno-agendamento'].objeto.emailEnviar">
                                                        <label for="lembrete-retorno-agendamento-email"><span class="checkbox-icon"></span> E-mail</label>
                                                    </div>
                                                    <br>
                                                    <div class="checkbox">
                                                        <input type="checkbox" id="lembrete-retorno-agendamento-whatsapp" true-value="1" false-value="0" v-model="form['lembrete-retorno-agendamento'].objeto.whatsappEnviar">
                                                        <label for="lembrete-retorno-agendamento-whatsapp"><span class="checkbox-icon"></span> WhatsApp</label>
                                                    </div>
                                                    <br>
                                                    <div class="checkbox">
                                                        <input type="checkbox" id="lembrete-retorno-agendamento-push" true-value="1" false-value="0" v-model="form['lembrete-retorno-agendamento'].objeto.pushEnviar">
                                                        <label for="lembrete-retorno-agendamento-push"><span class="checkbox-icon"></span> Notificação push</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-xl-12"></div>

                                            <div v-show="form['lembrete-retorno-agendamento'].objeto.smsEnviar == 1" class="col-xl-12 margin-bottom-25">
                                                <hr>
                                                <h3>
                                                    <i class="las la-info-circle"></i>
                                                    SMS
                                                </h3>
                                            </div>

                                            <div v-show="form['lembrete-retorno-agendamento'].objeto.smsEnviar == 1" class="col-xl-12 col-md-12 col-lg-12">
                                                <div class="submit-field">
                                                    <h5>Texto que será enviado via SMS</h5>
                                                    <textarea placeholder="..." class="with-border" v-model="form['lembrete-retorno-agendamento'].objeto.smsTexto" style="min-height: 70px;"></textarea>
                                                </div>
                                            </div>
                                            <div class="col-xl-12"></div>

                                            <div v-show="form['lembrete-retorno-agendamento'].objeto.emailEnviar == 1" class="col-xl-12 margin-bottom-25">
                                                <hr>
                                                <h3>
                                                    <i class="las la-info-circle"></i>
                                                    E-mail
                                                </h3>
                                            </div>
                                            <div v-show="form['lembrete-retorno-agendamento'].objeto.emailEnviar == 1" class="col-xl-6 col-md-6 col-lg-10">
                                                <div class="submit-field">
                                                    <h5>Assunto do e-mail</h5>
                                                    <input type="text" placeholder="..." class="with-border" v-model="form['lembrete-retorno-agendamento'].objeto.emailAssunto">
                                                </div>
                                            </div>

                                            <div v-show="form['lembrete-retorno-agendamento'].objeto.emailEnviar == 1" class="col-xl-6 col-md-6 col-lg-10">
                                                <div class="submit-field">
                                                    <h5>Título do e-mail</h5>
                                                    <input type="text" placeholder="..." class="with-border" v-model="form['lembrete-retorno-agendamento'].objeto.emailTitulo">
                                                </div>
                                            </div>                                            

                                            <div v-show="form['lembrete-retorno-agendamento'].objeto.emailEnviar == 1" class="col-xl-12 col-md-12 col-lg-12">
                                                <div class="submit-field">
                                                    <h5>Texto do e-mail</h5>
                                                    <trumbowyg v-model="form['lembrete-retorno-agendamento'].objeto.emailTexto" :config="config" style="height: 400px;" class="" name="lembreteRetornoAgendamentoEmailTexto"></trumbowyg>
                                                   
                                                </div>
                                            </div>

                                            <div v-show="form['lembrete-retorno-agendamento'].objeto.whatsappEnviar == 1" class="col-xl-12 margin-bottom-25">
                                                <hr>
                                                <h3>
                                                    <i class="las la-info-circle"></i>
                                                    WhatsApp
                                                </h3>
                                            </div>

                                            <div v-show="form['lembrete-retorno-agendamento'].objeto.whatsappEnviar == 1" class="col-xl-12 col-md-12 col-lg-12">
                                                <div class="submit-field">
                                                    <h5>Texto da mensagem a ser enviada via WhatsApp</h5>
                                                    <textarea placeholder="..." class="with-border" style="min-height: 100px;" v-model="form['lembrete-retorno-agendamento'].objeto.whatsappTexto"></textarea>
                                                </div>
                                            </div>                                            
                                            <div class="col-xl-12"></div>
                                            <div v-show="form['lembrete-retorno-agendamento'].objeto.pushEnviar == 1" class="col-xl-12 margin-bottom-25">
                                                <hr>
                                                <h3>
                                                    <i class="las la-info-circle"></i>
                                                    Notificação push
                                                </h3>
                                            </div>
                                            <div v-show="form['lembrete-retorno-agendamento'].objeto.pushEnviar == 1" class="col-xl-6 col-md-6 col-lg-10">
                                                <div class="submit-field">
                                                    <h5>Título da notificação</h5>
                                                    <input type="text" placeholder="..." v-model="form['lembrete-retorno-agendamento'].objeto.pushTitulo" class="with-border">
                                                </div>
                                            </div>
                                            <div v-show="form['lembrete-retorno-agendamento'].objeto.pushEnviar == 1" class="col-xl-6 col-md-6 col-lg-10">
                                                <div class="submit-field">
                                                    <h5>Link (opcional)</h5>
                                                    <input type="text" placeholder="..." v-model="form['lembrete-retorno-agendamento'].objeto.pushLink" class="with-border">
                                                </div>
                                            </div>
                                            <div v-show="form['lembrete-retorno-agendamento'].objeto.pushEnviar == 1" class="col-xl-12 col-md-12 col-lg-12 col-xs-12">
                                                <div class="submit-field">
                                                    <h5>Texto da notificação</h5>
                                                    <textarea placeholder="..." class="with-border" v-model="form['lembrete-retorno-agendamento'].objeto.pushTexto" style="min-height: 80px;"></textarea>
                                                </div>
                                            </div>    

                                            
                                            <div class="col-xl-12 margin-bottom-20">
                                                <button type="submit" class="button green block-mobile">
                                                    <i class="las la-save"></i>
                                                    Salvar alterações
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>                              
                        </div>  -->

                        <div class="col-xl-12 margin-top-10" v-show="tab == 'feedback'">
                            <hr>
                            <form type="post" v-on:submit.prevent="salvar()">
                                <div class="row">
                                    <div class="col-xl-12 margin-bottom-15 margin-top-10">
                                        <h3>
                                            <i class="las la-thumbs-up"></i>                                        
                                            Avaliações / Recomendações
                                        </h3>
                                    </div>
                                    <div class="col-xl-12 col-xs-12 col-lg-12">
                                        <div class="row">
                                            <div class="col-xl-8 col-xs-12 col-md-8 col-lg-8 margin-top-10">
                                                <div class="submit-field">
                                                    <h5>Link para avaliar no Google</h5>
                                                    <input type="text" placeholder="..." v-model="form['feedback'].objeto.link" class="with-border">
                                                </div>
                                            </div>         
                                            <div class="col-xl-6 col-md-6 col-lg-10 col-xs-12">
                                                <div class="submit-field">
                                                    <h5>Enviar depois de quantos minutos?</h5>
                                                    <input style="width: 90px;" type="number" placeholder="..." class="with-border" v-model="form['feedback'].objeto.tempo">
                                                </div>
                                            </div>
                                            <div class="col-xl-12"></div>
                                            <div class="col-xl-6 col-md-6 col-lg-10">
                                                <div class="submit-field">
                                                    <h5>Onde será enviado</h5>
                                                    <div class="checkbox">
                                                        <input type="checkbox" id="feedback-sms" true-value="1" false-value="0" v-model="form['feedback'].objeto.smsEnviar">
                                                        <label for="feedback-sms"><span class="checkbox-icon"></span> SMS</label>
                                                    </div>
                                                    <br>
                                                    <div class="checkbox">
                                                        <input type="checkbox" id="feedback-email" true-value="1" false-value="0" v-model="form['feedback'].objeto.emailEnviar">
                                                        <label for="feedback-email"><span class="checkbox-icon"></span> E-mail</label>
                                                    </div>
                                                    <br>
                                                    <div class="checkbox">
                                                        <input type="checkbox" id="feedback-whatsapp" true-value="1" false-value="0" v-model="form['feedback'].objeto.whatsappEnviar">
                                                        <label for="feedback-whatsapp"><span class="checkbox-icon"></span> WhatsApp</label>
                                                    </div>
                                                    <br>
                                                    <div class="checkbox">
                                                        <input type="checkbox" id="feedback-push" true-value="1" false-value="0" v-model="form['feedback'].objeto.pushEnviar">
                                                        <label for="feedback-push"><span class="checkbox-icon"></span> Notificação push</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-xl-12"></div>

                                            <div v-show="form['feedback'].objeto.smsEnviar == 1" class="col-xl-12 margin-bottom-25">
                                                <hr>
                                                <h3>
                                                    <i class="las la-info-circle"></i>
                                                    SMS
                                                </h3>
                                            </div>

                                            <div v-show="form['feedback'].objeto.smsEnviar == 1" class="col-xl-12 col-md-12 col-lg-12">
                                                <div class="submit-field">
                                                    <h5>Texto que será enviado via SMS</h5>
                                                    <textarea placeholder="..." class="with-border" v-model="form['feedback'].objeto.smsTexto" style="min-height: 70px;"></textarea>
                                                </div>
                                            </div>
                                            <div class="col-xl-12"></div>

                                            <div v-show="form['feedback'].objeto.emailEnviar == 1" class="col-xl-12 margin-bottom-25">
                                                <hr>
                                                <h3>
                                                    <i class="las la-info-circle"></i>
                                                    E-mail
                                                </h3>
                                            </div>
                                            <div v-show="form['feedback'].objeto.emailEnviar == 1" class="col-xl-6 col-md-6 col-lg-10">
                                                <div class="submit-field">
                                                    <h5>Assunto do e-mail</h5>
                                                    <input type="text" placeholder="..." class="with-border" v-model="form['feedback'].objeto.emailAssunto">
                                                </div>
                                            </div>

                                            <div v-show="form['feedback'].objeto.emailEnviar == 1" class="col-xl-6 col-md-6 col-lg-10">
                                                <div class="submit-field">
                                                    <h5>Título do e-mail</h5>
                                                    <input type="text" placeholder="..." class="with-border" v-model="form['feedback'].objeto.emailTitulo">
                                                </div>
                                            </div>                                            

                                            <div v-show="form['feedback'].objeto.emailEnviar == 1" class="col-xl-12 col-md-12 col-lg-12">
                                                <div class="submit-field">
                                                    <h5>Texto do e-mail</h5>
                                                    <trumbowyg v-model="form['feedback'].objeto.emailTexto" :config="config" style="height: 400px;" class="" name="feedbackEmailTexto"></trumbowyg>
                                                    <!-- <textarea placeholder="..." class="with-border" style="min-height: 100px;" v-model="form['feedback'].objeto.emailTexto"></textarea> -->
                                                </div>
                                            </div>

                                            <div v-show="form['feedback'].objeto.whatsappEnviar == 1" class="col-xl-12 margin-bottom-25">
                                                <hr>
                                                <h3>
                                                    <i class="las la-info-circle"></i>
                                                    WhatsApp
                                                </h3>
                                            </div>

                                            <div v-show="form['feedback'].objeto.whatsappEnviar == 1" class="col-xl-12 col-md-12 col-lg-12">
                                                <div class="submit-field">
                                                    <h5>Texto da mensagem a ser enviada via WhatsApp</h5>
                                                    <textarea placeholder="..." class="with-border" style="min-height: 100px;" v-model="form['feedback'].objeto.whatsappTexto"></textarea>
                                                </div>
                                            </div>                                            
                                            <div class="col-xl-12"></div>
                                            <div v-show="form['feedback'].objeto.pushEnviar == 1" class="col-xl-12 margin-bottom-25">
                                                <hr>
                                                <h3>
                                                    <i class="las la-info-circle"></i>
                                                    Notificação push
                                                </h3>
                                            </div>
                                            <div v-show="form['feedback'].objeto.pushEnviar == 1" class="col-xl-6 col-md-6 col-lg-10">
                                                <div class="submit-field">
                                                    <h5>Título da notificação</h5>
                                                    <input type="text" placeholder="..." v-model="form['feedback'].objeto.pushTitulo" class="with-border">
                                                </div>
                                            </div>
                                            <div v-show="form['feedback'].objeto.pushEnviar == 1" class="col-xl-12 col-md-12 col-lg-12 col-xs-12">
                                                <div class="submit-field">
                                                    <h5>Texto da notificação</h5>
                                                    <textarea placeholder="..." class="with-border" v-model="form['feedback'].objeto.pushTexto" style="min-height: 80px;"></textarea>
                                                </div>
                                            </div>    

                                            <!-- Button -->
                                            <div class="col-xl-12 margin-bottom-20">
                                                <button type="submit" class="button green block-mobile">
                                                    <i class="las la-save"></i>
                                                    Salvar alterações
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>  
                        </div> 


                        <div class="col-xl-12 margin-top-10" v-if="tab == 'sintomas'">
                            <hr>
                            <form type="post" v-on:submit.prevent="salvar()">
                                <div class="row">
                                    <div class="col-xl-12 margin-bottom-15 margin-top-10">
                                        <h3>
                                            <i class="las la-clipboard-list"></i>
                                            Popup de sintomas

                                            <a class="float-right" style="font-size: 12px;" v-on:click="$root.openSintomas()">(Ver exemplo)</a>
                                        </h3>
                                    </div>
                                    <div class="col-xl-12 col-xs-12 col-lg-12">
                                        <div class="row">

                                            <div class="col-xl-6 col-md-6 col-lg-10">
                                                <div class="submit-field">
                                                    <div class="checkbox">
                                                        <input type="checkbox" id="sintomas-habilitado" v-model="form.sintomas.objeto.habilitado" true-value="1" false-value="0">
                                                        <label for="sintomas-habilitado"><span class="checkbox-icon"></span> Envio ativado</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-xl-12"></div>
                                            <div class="col-xl-6 col-md-6 col-lg-10 margin-top-10">
                                                <div class="submit-field">
                                                    <h5>Título da notificação</h5>
                                                    <input type="text" placeholder="Como você está se sentindo hoje?" v-model="form.sintomas.objeto.pushTitulo" class="with-border">
                                                </div>
                                            </div>
                                            <div class="col-xl-12 col-md-12 col-lg-12 margin-bottom-20">
                                                <div class="submit-field">
                                                    <h5>Texto da notificação</h5>
                                                    <textarea placeholder="Toque aqui para nos contar como você está =)" v-model="form.sintomas.objeto.pushTexto" class="with-border" style="min-height: 80px;"></textarea>
                                                </div>
                                            </div>        

                                            <div class="col-xs-12 margin-bottom-0">
                                                <div class="row margin-bottom-10" v-for="(item, index) in form.sintomas.objeto.itens">
                                                    <div class="col-xl-12">
                                                        <hr class="margin-bottom-30">
                                                    </div>        

                                                    <div class="col-xl-6 col-md-6 col-lg-10">
                                                        <div class="submit-field">
                                                            <h5>Pergunta #{{index+1}}</h5>
                                                            <div class="row">
                                                                <div class="col-xs-11">
                                                                    <textarea placeholder="..." name="texto" v-model="item.texto" class="with-border margin-bottom-5" style="min-height: 50px;"></textarea>
                                                                </div>
                                                                <div class="col-xs-1">
                                                                    <a class="margin-top-9 margin-right-10 block close-red" v-on:click="del(form.sintomas.objeto.itens, item)">
                                                                        <i class="las la-times"></i>
                                                                    </a>
                                                                </div>
                                                            </div>                                                    
                                                        </div>
                                                    </div>    
                                                    <div class="col-xl-6 col-md-6 col-lg-10">
                                                        <div class="submit-field padding-left-10">
                                                            <h5>Alternativas</h5>
                                                            <div class="row" v-for="(item2, index2) in item.itens">
                                                                <div class="col-xs-11">
                                                                    <input type="text" placeholder="..." v-model="item2.texto" class="with-border margin-bottom-2">
                                                                </div>
                                                                <div class="col-xs-1">
                                                                    <a class="margin-top-9 margin-right-10 block close-red" v-on:click="del(form.sintomas.objeto.itens[index].itens, item2)">
                                                                        <i class="las la-times"></i>
                                                                    </a>
                                                                </div>
                                                            </div>

                                                            <div class="row">
                                                                <div class="col-xs-12">
                                                                    <a class="button-basic margin-top-8" v-on:click="add(form.sintomas.objeto.itens[index].itens, {'texto': ''})">
                                                                        <i class="las la-plus"></i>
                                                                        Adicionar nova <b>alternativa</b>
                                                                    </a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>                                                                                       
                                                </div>                                                                                       
                                            </div>                                                                                                                              

                                            <!-- Button -->
                                            <div class="col-xl-12 margin-bottom-20 margin-top-10">
                                                <hr>
                                                <a class="button-basic margin-top-8" v-on:click="add(form.sintomas.objeto.itens, {'texto': '', 'itens': []})">
                                                    <i class="las la-plus"></i>
                                                    Adicionar nova <b>pergunta</b>
                                                </a>
                                                <hr>
                                            </div>
                                            <div class="col-xl-12 margin-bottom-20">
                                                <button type="submit" class="button green block-mobile">
                                                    <i class="las la-save"></i>
                                                    Salvar alterações
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form> 
                        </div> 


                        <div class="col-xl-12 margin-top-10" v-if="tab == 'termos-de-uso'">
                            <hr>
                            <form type="post" v-on:submit.prevent="salvar()">
                                <div class="row">
                                    <div class="col-xl-12 margin-bottom-15 margin-top-10">
                                        <h3>
                                            <i class="las la-file-alt"></i>
                                            Termos de uso
                                        </h3>
                                    </div>
                                    <div class="col-xl-12 col-xs-12 col-lg-12">
                                        <div class="row">

                                            <div class="col-xl-12 margin-bottom-15">
                                                <div class="submit-field">
                                                    <h5>Conteúdo:</h5>
                                                    <trumbowyg v-model="form['termos-de-uso'].objeto.conteudo" :config="config" class="" name="termosUso"></trumbowyg>
                                                </div>
                                            </div>                                          

                                            <div class="col-xl-12 margin-bottom-20">
                                                <button type="submit" class="button green block-mobile">
                                                    <i class="las la-save"></i>
                                                    Salvar alterações
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div> 


                        <div class="col-xl-12 margin-top-10" v-if="tab == 'politicas-de-privacidade'">
                            <hr>
                            <form type="post" v-on:submit.prevent="salvar()">
                                <div class="row">
                                    <div class="col-xl-12 margin-bottom-15 margin-top-10">
                                        <h3>
                                            <i class="las la-file-alt"></i>
                                            Políticas de privacidade
                                        </h3>
                                    </div>
                                    <div class="col-xl-12 col-xs-12 col-lg-12">
                                        <div class="row">

                                            <div class="col-xl-12 margin-bottom-15">
                                                <div class="submit-field">
                                                    <h5>Conteúdo:</h5>
                                                    <trumbowyg v-model="form['politicas-de-privacidade'].objeto.conteudo" :config="config" style="height: 400px;" class="" name="politicasPrivacidade"></trumbowyg>
                                                </div>
                                            </div>                                          

                                            <div class="col-xl-12 margin-bottom-20">
                                                <button type="submit" class="button green block-mobile">
                                                    <i class="las la-save"></i>
                                                    Salvar alterações
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>    
                        </div>        


                        <div class="col-xl-12 margin-top-10" v-show="tab == 'solicitar-uso-de-dados'">
                            <hr>
                            <form type="post" v-on:submit.prevent="salvar()">
                                <div class="row">
                                    <div class="col-xl-12 margin-bottom-15 margin-top-10">
                                        <h3>
                                            <i class="las la-lock"></i>
                                            Solicitar uso de dados
                                        </h3>
                                    </div>
                                    <div class="col-xl-12 col-xs-12 col-lg-12">
                                        <div class="row">
                                            <div class="col-xl-12"></div>
                                            <div class="col-xl-6 col-md-6 col-lg-10">
                                                <div class="submit-field">
                                                    <h5>Onde será enviado</h5>
                                                    <div class="checkbox">
                                                        <input type="checkbox" id="solicitar-uso-de-dados-sms" true-value="1" false-value="0" v-model="form['solicitar-uso-de-dados'].objeto.smsEnviar">
                                                        <label for="solicitar-uso-de-dados-sms"><span class="checkbox-icon"></span> SMS</label>
                                                    </div>
                                                    <br>
<!--                                                     <div class="checkbox">
                                                        <input type="checkbox" id="solicitar-uso-de-dados-email" true-value="1" false-value="0" v-model="form['solicitar-uso-de-dados'].objeto.emailEnviar">
                                                        <label for="solicitar-uso-de-dados-email"><span class="checkbox-icon"></span> E-mail</label>
                                                    </div>
                                                    <br> -->
                                                    <div class="checkbox">
                                                        <input type="checkbox" id="solicitar-uso-de-dados-whatsapp" true-value="1" false-value="0" v-model="form['solicitar-uso-de-dados'].objeto.whatsappEnviar">
                                                        <label for="solicitar-uso-de-dados-whatsapp"><span class="checkbox-icon"></span> WhatsApp</label>
                                                    </div>
                                                    <br>
                                                    <div class="checkbox">
                                                        <input type="checkbox" id="solicitar-uso-de-dados-push" true-value="1" false-value="0" v-model="form['solicitar-uso-de-dados'].objeto.pushEnviar">
                                                        <label for="solicitar-uso-de-dados-push"><span class="checkbox-icon"></span> Notificação push</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-xl-12"></div>

                                            <div v-show="form['solicitar-uso-de-dados'].objeto.smsEnviar == 1" class="col-xl-12 margin-bottom-25">
                                                <hr>
                                                <h3>
                                                    <i class="las la-info-circle"></i>
                                                    SMS
                                                </h3>
                                            </div>

                                            <div v-show="form['solicitar-uso-de-dados'].objeto.smsEnviar == 1" class="col-xl-12 col-md-12 col-lg-12">
                                                <div class="submit-field">
                                                    <h5>Texto que será enviado via SMS</h5>
                                                    <textarea placeholder="..." class="with-border" v-model="form['solicitar-uso-de-dados'].objeto.smsTexto" style="min-height: 70px;"></textarea>
                                                </div>
                                            </div>
                                            <div class="col-xl-12"></div>
<!-- 
                                            <div v-show="form['solicitar-uso-de-dados'].objeto.emailEnviar == 1" class="col-xl-12 margin-bottom-25">
                                                <hr>
                                                <h3>
                                                    <i class="las la-info-circle"></i>
                                                    E-mail
                                                </h3>
                                            </div>
                                            <div v-show="form['solicitar-uso-de-dados'].objeto.emailEnviar == 1" class="col-xl-6 col-md-6 col-lg-10">
                                                <div class="submit-field">
                                                    <h5>Assunto do e-mail</h5>
                                                    <input type="text" placeholder="..." class="with-border" v-model="form['solicitar-uso-de-dados'].objeto.emailAssunto">
                                                </div>
                                            </div>

                                            <div v-show="form['solicitar-uso-de-dados'].objeto.emailEnviar == 1" class="col-xl-6 col-md-6 col-lg-10">
                                                <div class="submit-field">
                                                    <h5>Título do e-mail</h5>
                                                    <input type="text" placeholder="..." class="with-border" v-model="form['solicitar-uso-de-dados'].objeto.emailTitulo">
                                                </div>
                                            </div>                                            

                                            <div v-show="form['solicitar-uso-de-dados'].objeto.emailEnviar == 1" class="col-xl-12 col-md-12 col-lg-12">
                                                <div class="submit-field">
                                                    <h5>Texto do e-mail</h5>
                                                    <trumbowyg v-model="form['solicitar-uso-de-dados'].objeto.emailTexto" :config="config" style="height: 400px;" class="" name="lembreteAgendamentoEmailTexto"></trumbowyg>
                                                </div>
                                            </div> -->

                                            <div v-show="form['solicitar-uso-de-dados'].objeto.whatsappEnviar == 1" class="col-xl-12 margin-bottom-25">
                                                <hr>
                                                <h3>
                                                    <i class="las la-info-circle"></i>
                                                    WhatsApp
                                                </h3>
                                            </div>

                                            <div v-show="form['solicitar-uso-de-dados'].objeto.whatsappEnviar == 1" class="col-xl-12 col-md-12 col-lg-12">
                                                <div class="submit-field">
                                                    <h5>Texto da mensagem a ser enviada via WhatsApp</h5>
                                                    <textarea placeholder="..." class="with-border" style="min-height: 180px;" v-model="form['solicitar-uso-de-dados'].objeto.whatsappTexto"></textarea>
                                                </div>
                                            </div>                                            
                                            <div class="col-xl-12"></div>
                                            <div v-show="form['solicitar-uso-de-dados'].objeto.pushEnviar == 1" class="col-xl-12 margin-bottom-25">
                                                <hr>
                                                <h3>
                                                    <i class="las la-info-circle"></i>
                                                    Notificação push
                                                </h3>
                                            </div>
                                            <div v-show="form['solicitar-uso-de-dados'].objeto.pushEnviar == 1" class="col-xl-6 col-md-6 col-lg-10">
                                                <div class="submit-field">
                                                    <h5>Título da notificação</h5>
                                                    <input type="text" placeholder="..." v-model="form['solicitar-uso-de-dados'].objeto.pushTitulo" class="with-border">
                                                </div>
                                            </div>
<!--                                             <div v-show="form['solicitar-uso-de-dados'].objeto.pushEnviar == 1" class="col-xl-6 col-md-6 col-lg-10">
                                                <div class="submit-field">
                                                    <h5>Link (opcional)</h5>
                                                    <input type="text" placeholder="..." v-model="form['solicitar-uso-de-dados'].objeto.pushLink" class="with-border">
                                                </div>
                                            </div> -->
                                            <div v-show="form['solicitar-uso-de-dados'].objeto.pushEnviar == 1" class="col-xl-12 col-md-12 col-lg-12 col-xs-12">
                                                <div class="submit-field">
                                                    <h5>Texto da notificação</h5>
                                                    <textarea placeholder="..." class="with-border" v-model="form['solicitar-uso-de-dados'].objeto.pushTexto" style="min-height: 180px;"></textarea>
                                                </div>
                                            </div>        


                                            <!-- Button -->
                                            <div class="col-xl-12 margin-bottom-20">
                                                <button type="submit" class="button green block-mobile">
                                                    <i class="las la-save"></i>
                                                    Salvar alterações
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>   


                        <div class="col-xl-12 margin-top-10" v-show="tab == 'menu'">
                            <hr>
                            <form type="post" v-on:submit.prevent="salvar()">
                                <div class="row">
                                    <div class="col-xl-12 margin-bottom-15 margin-top-10">
                                        <h3>
                                            <i class="las la-bars"></i>
                                            Itens do menu
                                        </h3>
                                    </div>
                                    <div class="col-xl-12 col-xs-12 col-lg-12">
                                        <div class="row">
                                            <div class="col-xl-12"></div>

                                            <div class="col-xl-4 col-xs-12 col-md-6 col-lg-10">
                                                <div class="submit-field">
                                                    <h5 class="margin-bottom-10">Paciente</h5>
                                                    <div class="checkbox">
                                                        <input type="checkbox" id="paciente-menu-1" v-model="form['menu'].objeto.paciente.agendarConsulta">
                                                        <label for="paciente-menu-1"><span class="checkbox-icon"></span> Agendar consulta</label>
                                                    </div>
                                                    <br>
                                                    <div class="checkbox">
                                                        <input type="checkbox" id="paciente-menu-2" v-model="form['menu'].objeto.paciente.meusAgendamentos">
                                                        <label for="paciente-menu-2"><span class="checkbox-icon"></span> Meus agendamentos</label>
                                                    </div>
                                                    <br>
                                                    <div class="checkbox">
                                                        <input type="checkbox" id="paciente-menu-3" v-model="form['menu'].objeto.paciente.dicasSemanais">
                                                        <label for="paciente-menu-3"><span class="checkbox-icon"></span> Dicas semanais</label>
                                                    </div>
                                                    <br>
                                                    <div class="checkbox">
                                                        <input type="checkbox" id="paciente-menu-4" v-model="form['menu'].objeto.paciente.receitasAtestados">
                                                        <label for="paciente-menu-4"><span class="checkbox-icon"></span> Receitas e atestados</label>
                                                    </div>
                                                    <br>
                                                    <div class="checkbox">
                                                        <input type="checkbox" id="paciente-menu-5" v-model="form['menu'].objeto.paciente.meusExames">
                                                        <label for="paciente-menu-5"><span class="checkbox-icon"></span> Meus exames</label>
                                                    </div>
                                                    <br>
                                                    <div class="checkbox">
                                                        <input type="checkbox" id="paciente-menu-6" v-model="form['menu'].objeto.paciente.meusDocumentos">
                                                        <label for="paciente-menu-6"><span class="checkbox-icon"></span> Meus documentos</label>
                                                    </div>
                                                    <br>                                                    
                                                    <div class="checkbox">
                                                        <input type="checkbox" id="paciente-menu-7" v-model="form['menu'].objeto.paciente.ged">
                                                        <label for="paciente-menu-7"><span class="checkbox-icon"></span> GED</label>
                                                    </div>
                                                    <br>
                                                    <div class="checkbox">
                                                        <input type="checkbox" id="paciente-menu-8" v-model="form['menu'].objeto.paciente.minhaConta">
                                                        <label for="paciente-menu-8"><span class="checkbox-icon"></span> Minha conta</label>
                                                    </div>
                                                    <br>
                                                    <div class="checkbox">
                                                        <input type="checkbox" id="paciente-menu-9" v-model="form['menu'].objeto.paciente.sair">
                                                        <label for="paciente-menu-9"><span class="checkbox-icon"></span> Sair</label>
                                                    </div>                                                    

                                                </div>
                                            </div>
                                            <!-- <div class="col-xs-12 hidden-xl hidden-lg"></div> -->

                                            
                                            <div class="col-xl-4 col-xs-12 col-md-6 col-lg-10">
                                                <div class="submit-field">
                                                    <h5 class="margin-bottom-10">Profissional</h5>
                                                    <div class="checkbox">
                                                        <input type="checkbox" id="profissional-menu-1" v-model="form['menu'].objeto.profissional.agendamentos">
                                                        <label for="profissional-menu-1"><span class="checkbox-icon"></span> Agendamentos</label>
                                                    </div>
                                                    <br>
                                                    <div class="checkbox">
                                                        <input type="checkbox" id="profissional-menu-2" v-model="form['menu'].objeto.profissional.pacientes">
                                                        <label for="profissional-menu-2"><span class="checkbox-icon"></span> Pacientes</label>
                                                    </div>
                                                    <br>
                                                    <div class="checkbox">
                                                        <input type="checkbox" id="profissional-menu-3" v-model="form['menu'].objeto.profissional.honorariosMedicos">
                                                        <label for="profissional-menu-3"><span class="checkbox-icon"></span> Honorários Médicos</label>
                                                    </div>
                                                    <br>                                                    
                                                    <div class="checkbox">
                                                        <input type="checkbox" id="profissional-menu-4" v-model="form['menu'].objeto.profissional.receitasAtestados">
                                                        <label for="profissional-menu-4"><span class="checkbox-icon"></span> Receitas e atestados</label>
                                                    </div>
                                                    <br>
                                                    <div class="checkbox">
                                                        <input type="checkbox" id="profissional-menu-5" v-model="form['menu'].objeto.profissional.minhaConta">
                                                        <label for="profissional-menu-5"><span class="checkbox-icon"></span> Minha conta</label>
                                                    </div>
                                                    <br>
                                                    <div class="checkbox">
                                                        <input type="checkbox" id="profissional-menu-6" v-model="form['menu'].objeto.profissional.sair">
                                                        <label for="profissional-menu-6"><span class="checkbox-icon"></span> Sair</label>
                                                    </div>                                                    

                                                </div>
                                            </div>

                                            <div class="col-xl-4 col-xs-12 col-md-6 col-lg-10">
                                                <div class="submit-field">
                                                    <h5 class="margin-bottom-10">Marketing</h5>
                                                    <div class="checkbox">
                                                        <input type="checkbox" id="marketing-menu-1" v-model="form['menu'].objeto.marketing.dicasSemanais">
                                                        <label for="marketing-menu-1"><span class="checkbox-icon"></span> Dicas semanais</label>
                                                    </div>
                                                    <br>
                                                    <div class="checkbox">
                                                        <input type="checkbox" id="marketing-menu-2" v-model="form['menu'].objeto.marketing.campanhas">
                                                        <label for="marketing-menu-2"><span class="checkbox-icon"></span> Campanhas</label>
                                                    </div>
                                                    <br>
                                                    <div class="checkbox">
                                                        <input type="checkbox" id="marketing-menu-3" v-model="form['menu'].objeto.marketing.muralRecados">
                                                        <label for="marketing-menu-3"><span class="checkbox-icon"></span> Mural de recados</label>
                                                    </div>
                                                    <br>
                                                    <div class="checkbox">
                                                        <input type="checkbox" id="marketing-menu-7" v-model="form['menu'].objeto.marketing.minhaConta">
                                                        <label for="marketing-menu-7"><span class="checkbox-icon"></span> Minha conta</label>
                                                    </div>
                                                    <br>
                                                    <div class="checkbox">
                                                        <input type="checkbox" id="marketing-menu-8" v-model="form['menu'].objeto.marketing.sair">
                                                        <label for="marketing-menu-8"><span class="checkbox-icon"></span> Sair</label>
                                                    </div>                                                    

                                                </div>
                                            </div>
                                                            
                                            <div class="col-xl-4 col-xs-12 col-md-6 col-lg-10">
                                                <div class="submit-field">
                                                    <h5 class="margin-bottom-10">Controladoria</h5>
                                                    <div class="checkbox">
                                                        <input type="checkbox" id="controladoria-menu-1" v-model="form['menu'].objeto.controladoria.agendarConsulta">
                                                        <label for="controladoria-menu-1"><span class="checkbox-icon"></span> Agendar consulta</label>
                                                    </div>
                                                    <br>
                                                    <div class="checkbox">
                                                        <input type="checkbox" id="controladoria-menu-2" v-model="form['menu'].objeto.controladoria.meusAgendamentos">
                                                        <label for="controladoria-menu-2"><span class="checkbox-icon"></span> Meus agendamentos</label>
                                                    </div>
                                                    <br>
                                                    <div class="checkbox">
                                                        <input type="checkbox" id="controladoria-menu-3" v-model="form['menu'].objeto.controladoria.dicasSemanais">
                                                        <label for="controladoria-menu-3"><span class="checkbox-icon"></span> Dicas semanais</label>
                                                    </div>
                                                    <br>
                                                    <div class="checkbox">
                                                        <input type="checkbox" id="controladoria-menu-4" v-model="form['menu'].objeto.controladoria.receitasAtestados">
                                                        <label for="controladoria-menu-4"><span class="checkbox-icon"></span> Receitas e atestados</label>
                                                    </div>
                                                    <br>
                                                    <div class="checkbox">
                                                        <input type="checkbox" id="controladoria-menu-5" v-model="form['menu'].objeto.controladoria.meusExames">
                                                        <label for="controladoria-menu-5"><span class="checkbox-icon"></span> Meus exames</label>
                                                    </div>
                                                    <br>
                                                    <div class="checkbox">
                                                        <input type="checkbox" id="controladoria-menu-6" v-model="form['menu'].objeto.controladoria.meusDocumentos">
                                                        <label for="controladoria-menu-6"><span class="checkbox-icon"></span> Meus documentos</label>
                                                    </div>
                                                    <br>                                                    
                                                    <div class="checkbox">
                                                        <input type="checkbox" id="controladoria-menu-7" v-model="form['menu'].objeto.controladoria.ged">
                                                        <label for="controladoria-menu-7"><span class="checkbox-icon"></span> GED</label>
                                                    </div>
                                                    <br>
                                                    <div class="checkbox">
                                                        <input type="checkbox" id="controladoria-menu-9" v-model="form['menu'].objeto.controladoria.pacientes">
                                                        <label for="controladoria-menu-9"><span class="checkbox-icon"></span> Pacientes</label>
                                                    </div>
                                                    <br>
                                                    <div class="checkbox">
                                                        <input type="checkbox" id="controladoria-menu-10" v-model="form['menu'].objeto.controladoria.aprovacaoOrcamentaria">
                                                        <label for="controladoria-menu-10"><span class="checkbox-icon"></span> Aprovações</label>
                                                    </div>
                                                    <br>
                                                    <div class="checkbox">
                                                        <input type="checkbox" id="controladoria-menu-11" v-model="form['menu'].objeto.controladoria.alteracaoOrcamentaria">
                                                        <label for="controladoria-menu-11"><span class="checkbox-icon"></span> Orçamento</label>
                                                    </div>
                                                    <div style="padding-left: 25px">
                                                        <div class="checkbox">
                                                            <input type="checkbox" id="controladoria-menu-alteracao-orcamentaria-1" v-model="form['menu'].objeto.controladoria.alteracaoOrcamentariaTDC">
                                                            <label for="controladoria-menu-alteracao-orcamentaria-1"><span class="checkbox-icon"></span> Transferência em Despesa Corrente</label>
                                                        </div>
                                                        <br>
                                                        <div class="checkbox">
                                                            <input type="checkbox" id="controladoria-menu-alteracao-orcamentaria-2" v-model="form['menu'].objeto.controladoria.alteracaoOrcamentariaSDC">
                                                            <label for="controladoria-menu-alteracao-orcamentaria-2"><span class="checkbox-icon"></span> Suplementação em Despesa Corrente</label>
                                                        </div>   
                                                        <br>
                                                        <div class="checkbox">
                                                            <input type="checkbox" id="controladoria-menu-alteracao-orcamentaria-3" v-model="form['menu'].objeto.controladoria.alteracaoOrcamentariaTPE">
                                                            <label for="controladoria-menu-alteracao-orcamentaria-3"><span class="checkbox-icon"></span> Transferência em Planejamento Estratégico</label>
                                                        </div>   
                                                        <br>
                                                        <div class="checkbox">
                                                            <input type="checkbox" id="controladoria-menu-alteracao-orcamentaria-4" v-model="form['menu'].objeto.controladoria.alteracaoOrcamentariaTVO">
                                                            <label for="controladoria-menu-alteracao-orcamentaria-4"><span class="checkbox-icon"></span> Transferência de valor original</label>
                                                        </div>   
                                                        <br>
                                                        <div class="checkbox">
                                                            <input type="checkbox" id="controladoria-menu-alteracao-orcamentaria-5" v-model="form['menu'].objeto.controladoria.alteracaoOrcamentariaTPEDC">
                                                            <label for="controladoria-menu-alteracao-orcamentaria-5"><span class="checkbox-icon"></span> Transferência entre Planejamento Estratégico e Despesa Corrente</label>
                                                        </div>   
                                                        <br>
                                                        <div class="checkbox">
                                                            <input type="checkbox" id="controladoria-menu-alteracao-orcamentaria-6" v-model="form['menu'].objeto.controladoria.alteracaoOrcamentariaSCLPE">
                                                            <label for="controladoria-menu-alteracao-orcamentaria-6"><span class="checkbox-icon"></span> Suplementação / Corte / Liberação em Planejamento Estratégico</label>
                                                        </div>                                                                                                   
                                                    </div>                                                  
                                                    <div class="checkbox">
                                                        <input type="checkbox" id="controladoria-menu-12" v-model="form['menu'].objeto.controladoria.minhaConta">
                                                        <label for="controladoria-menu-12"><span class="checkbox-icon"></span> Minha conta</label>
                                                    </div>
                                                    <br>
                                                    <div class="checkbox">
                                                        <input type="checkbox" id="controladoria-menu-13" v-model="form['menu'].objeto.controladoria.sair">
                                                        <label for="controladoria-menu-13"><span class="checkbox-icon"></span> Sair</label>
                                                    </div>                                                    

                                                </div>
                                            </div>                                                                                    

                                            <div class="col-xl-4 col-xs-12 col-md-6 col-lg-10">
                                                <div class="submit-field">
                                                    <h5 class="margin-bottom-10">Coordenador</h5>
                                                    <div class="checkbox">
                                                        <input type="checkbox" id="coordenador-menu-1" v-model="form['menu'].objeto.coordenador.agendarConsulta">
                                                        <label for="coordenador-menu-1"><span class="checkbox-icon"></span> Agendar consulta</label>
                                                    </div>
                                                    <br>
                                                    <div class="checkbox">
                                                        <input type="checkbox" id="coordenador-menu-2" v-model="form['menu'].objeto.coordenador.meusAgendamentos">
                                                        <label for="coordenador-menu-2"><span class="checkbox-icon"></span> Meus agendamentos</label>
                                                    </div>
                                                    <br>
                                                    <div class="checkbox">
                                                        <input type="checkbox" id="coordenador-menu-3" v-model="form['menu'].objeto.coordenador.dicasSemanais">
                                                        <label for="coordenador-menu-3"><span class="checkbox-icon"></span> Dicas semanais</label>
                                                    </div>
                                                    <br>
                                                    <div class="checkbox">
                                                        <input type="checkbox" id="coordenador-menu-4" v-model="form['menu'].objeto.coordenador.receitasAtestados">
                                                        <label for="coordenador-menu-4"><span class="checkbox-icon"></span> Receitas e atestados</label>
                                                    </div>
                                                    <br>
                                                    <div class="checkbox">
                                                        <input type="checkbox" id="coordenador-menu-5" v-model="form['menu'].objeto.coordenador.meusExames">
                                                        <label for="coordenador-menu-5"><span class="checkbox-icon"></span> Meus exames</label>
                                                    </div>
                                                    <br>
                                                    <div class="checkbox">
                                                        <input type="checkbox" id="coordenador-menu-6" v-model="form['menu'].objeto.coordenador.meusDocumentos">
                                                        <label for="coordenador-menu-6"><span class="checkbox-icon"></span> Meus documentos</label>
                                                    </div>
                                                    <br>                                                    
                                                    <div class="checkbox">
                                                        <input type="checkbox" id="coordenador-menu-7" v-model="form['menu'].objeto.coordenador.ged">
                                                        <label for="coordenador-menu-7"><span class="checkbox-icon"></span> GED</label>
                                                    </div>
                                                    <br>                                                    
                                                    <div class="checkbox">
                                                        <input type="checkbox" id="coordenador-menu-9" v-model="form['menu'].objeto.coordenador.pacientes">
                                                        <label for="coordenador-menu-9"><span class="checkbox-icon"></span> Pacientes</label>
                                                    </div>
                                                    <br>
                                                    <div class="checkbox">
                                                        <input type="checkbox" id="coordenador-menu-10" v-model="form['menu'].objeto.coordenador.aprovacaoOrcamentaria">
                                                        <label for="coordenador-menu-10"><span class="checkbox-icon"></span> Aprovações</label>
                                                    </div>
                                                    <br>
                                                    <div class="checkbox">
                                                        <input type="checkbox" id="coordenador-menu-11" v-model="form['menu'].objeto.coordenador.alteracaoOrcamentaria">
                                                        <label for="coordenador-menu-11"><span class="checkbox-icon"></span> Orçamento</label>
                                                    </div>
                                                    <div style="padding-left: 25px">
                                                        <div class="checkbox">
                                                            <input type="checkbox" id="coordenador-menu-alteracao-orcamentaria-1" v-model="form['menu'].objeto.coordenador.alteracaoOrcamentariaTDC">
                                                            <label for="coordenador-menu-alteracao-orcamentaria-1"><span class="checkbox-icon"></span> Transferência em Despesa Corrente</label>
                                                        </div>
                                                        <br>
                                                        <div class="checkbox">
                                                            <input type="checkbox" id="coordenador-menu-alteracao-orcamentaria-2" v-model="form['menu'].objeto.coordenador.alteracaoOrcamentariaSDC">
                                                            <label for="coordenador-menu-alteracao-orcamentaria-2"><span class="checkbox-icon"></span> Suplementação em Despesa Corrente</label>
                                                        </div>   
                                                        <br>
                                                        <div class="checkbox">
                                                            <input type="checkbox" id="coordenador-menu-alteracao-orcamentaria-3" v-model="form['menu'].objeto.coordenador.alteracaoOrcamentariaTPE">
                                                            <label for="coordenador-menu-alteracao-orcamentaria-3"><span class="checkbox-icon"></span> Transferência em Planejamento Estratégico</label>
                                                        </div>   
                                                        <br>
                                                        <div class="checkbox">
                                                            <input type="checkbox" id="coordenador-menu-alteracao-orcamentaria-4" v-model="form['menu'].objeto.coordenador.alteracaoOrcamentariaTVO">
                                                            <label for="coordenador-menu-alteracao-orcamentaria-4"><span class="checkbox-icon"></span> Transferência de valor original</label>
                                                        </div>   
                                                        <br>
                                                        <div class="checkbox">
                                                            <input type="checkbox" id="coordenador-menu-alteracao-orcamentaria-5" v-model="form['menu'].objeto.coordenador.alteracaoOrcamentariaTPEDC">
                                                            <label for="coordenador-menu-alteracao-orcamentaria-5"><span class="checkbox-icon"></span> Transferência entre Planejamento Estratégico e Despesa Corrente</label>
                                                        </div>   
                                                        <br>
                                                        <div class="checkbox">
                                                            <input type="checkbox" id="coordenador-menu-alteracao-orcamentaria-6" v-model="form['menu'].objeto.coordenador.alteracaoOrcamentariaSCLPE">
                                                            <label for="coordenador-menu-alteracao-orcamentaria-6"><span class="checkbox-icon"></span> Suplementação / Corte / Liberação em Planejamento Estratégico</label>
                                                        </div>                                                                                                   
                                                    </div>                                  
                                                    <div class="checkbox">
                                                        <input type="checkbox" id="coordenador-menu-12" v-model="form['menu'].objeto.coordenador.minhaConta">
                                                        <label for="coordenador-menu-12"><span class="checkbox-icon"></span> Minha conta</label>
                                                    </div>
                                                    <br>
                                                    <div class="checkbox">
                                                        <input type="checkbox" id="coordenador-menu-13" v-model="form['menu'].objeto.coordenador.sair">
                                                        <label for="coordenador-menu-13"><span class="checkbox-icon"></span> Sair</label>
                                                    </div>                                                    

                                                </div>
                                            </div>                                                                                    

                                            <div class="col-xl-4 col-xs-12 col-md-6 col-lg-10">
                                                <div class="submit-field">
                                                    <h5 class="margin-bottom-10">Gerente</h5>
                                                    <div class="checkbox">
                                                        <input type="checkbox" id="gerente-menu-1" v-model="form['menu'].objeto.gerente.agendarConsulta">
                                                        <label for="gerente-menu-1"><span class="checkbox-icon"></span> Agendar consulta</label>
                                                    </div>
                                                    <br>
                                                    <div class="checkbox">
                                                        <input type="checkbox" id="gerente-menu-2" v-model="form['menu'].objeto.gerente.meusAgendamentos">
                                                        <label for="gerente-menu-2"><span class="checkbox-icon"></span> Meus agendamentos</label>
                                                    </div>
                                                    <br>
                                                    <div class="checkbox">
                                                        <input type="checkbox" id="gerente-menu-3" v-model="form['menu'].objeto.gerente.dicasSemanais">
                                                        <label for="gerente-menu-3"><span class="checkbox-icon"></span> Dicas semanais</label>
                                                    </div>
                                                    <br>
                                                    <div class="checkbox">
                                                        <input type="checkbox" id="gerente-menu-4" v-model="form['menu'].objeto.gerente.receitasAtestados">
                                                        <label for="gerente-menu-4"><span class="checkbox-icon"></span> Receitas e atestados</label>
                                                    </div>
                                                    <br>
                                                    <div class="checkbox">
                                                        <input type="checkbox" id="gerente-menu-5" v-model="form['menu'].objeto.gerente.meusExames">
                                                        <label for="gerente-menu-5"><span class="checkbox-icon"></span> Meus exames</label>
                                                    </div>
                                                    <br>
                                                    <div class="checkbox">
                                                        <input type="checkbox" id="gerente-menu-6" v-model="form['menu'].objeto.gerente.meusDocumentos">
                                                        <label for="gerente-menu-6"><span class="checkbox-icon"></span> Meus documentos</label>
                                                    </div>
                                                    <br>                                                    
                                                    <div class="checkbox">
                                                        <input type="checkbox" id="gerente-menu-7" v-model="form['menu'].objeto.gerente.ged">
                                                        <label for="gerente-menu-7"><span class="checkbox-icon"></span> GED</label>
                                                    </div>
                                                    <br>
                                                    <div class="checkbox">
                                                        <input type="checkbox" id="gerente-menu-8" v-model="form['menu'].objeto.gerente.pacientes">
                                                        <label for="gerente-menu-8"><span class="checkbox-icon"></span> Pacientes</label>
                                                    </div>
                                                    <br>
                                                    <div class="checkbox">
                                                        <input type="checkbox" id="gerente-menu-9" v-model="form['menu'].objeto.gerente.aprovacaoOrcamentaria">
                                                        <label for="gerente-menu-9"><span class="checkbox-icon"></span> Aprovações</label>
                                                    </div>
                                                    <br>
                                                    <div class="checkbox">
                                                        <input type="checkbox" id="gerente-menu-10" v-model="form['menu'].objeto.gerente.alteracaoOrcamentaria">
                                                        <label for="gerente-menu-10"><span class="checkbox-icon"></span> Orçamento</label>
                                                    </div>
                                                    <div style="padding-left: 25px">
                                                        <div class="checkbox">
                                                            <input type="checkbox" id="gerente-menu-alteracao-orcamentaria-1" v-model="form['menu'].objeto.gerente.alteracaoOrcamentariaTDC">
                                                            <label for="gerente-menu-alteracao-orcamentaria-1"><span class="checkbox-icon"></span> Transferência em Despesa Corrente</label>
                                                        </div>
                                                        <br>
                                                        <div class="checkbox">
                                                            <input type="checkbox" id="gerente-menu-alteracao-orcamentaria-2" v-model="form['menu'].objeto.gerente.alteracaoOrcamentariaSDC">
                                                            <label for="gerente-menu-alteracao-orcamentaria-2"><span class="checkbox-icon"></span> Suplementação em Despesa Corrente</label>
                                                        </div>   
                                                        <br>
                                                        <div class="checkbox">
                                                            <input type="checkbox" id="gerente-menu-alteracao-orcamentaria-3" v-model="form['menu'].objeto.gerente.alteracaoOrcamentariaTPE">
                                                            <label for="gerente-menu-alteracao-orcamentaria-3"><span class="checkbox-icon"></span> Transferência em Planejamento Estratégico</label>
                                                        </div>   
                                                        <br>
                                                        <div class="checkbox">
                                                            <input type="checkbox" id="gerente-menu-alteracao-orcamentaria-4" v-model="form['menu'].objeto.gerente.alteracaoOrcamentariaTVO">
                                                            <label for="gerente-menu-alteracao-orcamentaria-4"><span class="checkbox-icon"></span> Transferência de valor original</label>
                                                        </div>   
                                                        <br>
                                                        <div class="checkbox">
                                                            <input type="checkbox" id="gerente-menu-alteracao-orcamentaria-5" v-model="form['menu'].objeto.gerente.alteracaoOrcamentariaTPEDC">
                                                            <label for="gerente-menu-alteracao-orcamentaria-5"><span class="checkbox-icon"></span> Transferência entre Planejamento Estratégico e Despesa Corrente</label>
                                                        </div>   
                                                        <br>
                                                        <div class="checkbox">
                                                            <input type="checkbox" id="gerente-menu-alteracao-orcamentaria-6" v-model="form['menu'].objeto.gerente.alteracaoOrcamentariaSCLPE">
                                                            <label for="gerente-menu-alteracao-orcamentaria-6"><span class="checkbox-icon"></span> Suplementação / Corte / Liberação em Planejamento Estratégico</label>
                                                        </div>                                                                                                   
                                                    </div>
                                                    <div class="checkbox">
                                                        <input type="checkbox" id="gerente-menu-11" v-model="form['menu'].objeto.gerente.minhaConta">
                                                        <label for="gerente-menu-11"><span class="checkbox-icon"></span> Minha conta</label>
                                                    </div>
                                                    <br>
                                                    <div class="checkbox">
                                                        <input type="checkbox" id="gerente-menu-12" v-model="form['menu'].objeto.gerente.sair">
                                                        <label for="gerente-menu-12"><span class="checkbox-icon"></span> Sair</label>
                                                    </div>                                                    

                                                </div>
                                            </div>                                                                                    


                                            <!-- Button -->
                                            <div class="col-xl-12 margin-bottom-20 margin-top-20">
                                                <button type="submit" class="button green block-mobile">
                                                    <i class="las la-save"></i>
                                                    Salvar alterações
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>                                                                                                                  



                        <div class="col-xl-12 margin-top-10" v-show="tab == 'prontuario'">
                            <hr>
                            <form type="post" v-on:submit.prevent="salvar()">
                                <div class="row">
                                    <div class="col-xl-12 margin-bottom-15 margin-top-10">
                                        <h3>
                                            <i class="las la-cog"></i>
                                            Opções do prontuário
                                        </h3>
                                    </div>
                                    <div class="col-xl-12 col-xs-12 col-lg-12">
                                        <div class="row">
                                            <div class="col-xl-12"></div>

                                            <div class="col-xl-6 col-md-6 col-lg-10">
                                                <div class="submit-field">
                                                    <div class="checkbox">
                                                        <input type="checkbox" id="prontuario-itens-1" v-model="form['prontuario'].objeto.dados">
                                                        <label for="prontuario-itens-1"><span class="checkbox-icon"></span> Dados</label>
                                                    </div>
                                                    <br>
                                                    <div class="checkbox">
                                                        <input type="checkbox" id="prontuario-itens-2" v-model="form['prontuario'].objeto.avaliacoes">
                                                        <label for="prontuario-itens-2"><span class="checkbox-icon"></span> Avaliações</label>
                                                    </div>
                                                    <br>
                                                    <div class="checkbox">
                                                        <input type="checkbox" id="prontuario-itens-3" v-model="form['prontuario'].objeto.evolucoes">
                                                        <label for="prontuario-itens-3"><span class="checkbox-icon"></span> Evoluções</label>
                                                    </div>
                                                    <br>
                                                    <div class="checkbox">
                                                        <input type="checkbox" id="prontuario-itens-4" v-model="form['prontuario'].objeto.criarEvolucoes">
                                                        <label for="prontuario-itens-4"><span class="checkbox-icon"></span> Criar evoluções</label>
                                                    </div>
                                                    <br>                                                    
                                                    <div class="checkbox">
                                                        <input type="checkbox" id="prontuario-itens-5" v-model="form['prontuario'].objeto.exames">
                                                        <label for="prontuario-itens-5"><span class="checkbox-icon"></span> Exames</label>
                                                    </div>
                                                    <br>
                                                    <div class="checkbox">
                                                        <input type="checkbox" id="prontuario-itens-6" v-model="form['prontuario'].objeto.ged">
                                                        <label for="prontuario-itens-6"><span class="checkbox-icon"></span> GED</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-xl-12"></div>
                         

                                            <!-- Button -->
                                            <div class="col-xl-12 margin-bottom-20 margin-top-20">
                                                <button type="submit" class="button green block-mobile">
                                                    <i class="las la-save"></i>
                                                    Salvar alterações
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>                                                                                                                  


                        <div class="col-xl-12 margin-top-10" v-show="tab == 'filtro-campanha'">
                            <hr>
                            <!-- <form type="post" v-on:submit.prevent="salvar()"> -->
                                <div class="row">
                                    <div class="col-xl-12 margin-bottom-15 margin-top-10">
                                        <h3>
                                            <i class="las la-code"></i>
                                            Filtros de campanhas
                                        </h3>
                                    </div>
                                    <div class="col-xl-12 margin-bottom-20 margin-top-20">
                                        <button v-on:click="$root.go('CadastrarCampanhasFiltros')" type="button" class="button gray block-mobile">
                                            <i class="las la-plus"></i>
                                            Adicionar novo
                                        </button>
                                    </div>
                                    <div v-if="form['filtro-campanha']" class="col-xl-12 col-xs-12 col-lg-12">
                                        
                                        <div v-show="form['filtro-campanha'].itens.length == 0">
                                            <h5 class="margin-bottom-0 empty">
                                                <i class="las la-times"></i>                                          
                                                Nenhum resultado encontrado.
                                            </h5>  
                                        </div>   

                                        <div class="parent table-scroll margin-top-30" style="overflow-x: auto !important; border: 1px solid #ddd;" v-if="form['filtro-campanha'].itens.length > 0">

                                            <table class="child table table-bordered table-bordered-default">
                                                <thead>
                                                    <th style="min-width: 30px; width: 30px;">
                                                        Id
                                                    </th>
                                                    <th style="min-width: 300px; width: 300px;">
                                                        Nome
                                                    </th>
                                                    <th style="min-width: 250px; ">
                                                        Select
                                                    </th>
                                                    <th style="min-width: 100px; width: 100px;">
                                                        Data/hora
                                                    </th>
                                                    <th style="min-width: 110px; width: 110px;">
                                                        Ações
                                                    </th>                                                    
                                                </thead>
                                                <tbody>   
                                                    <tr v-for="(item, index) in form['filtro-campanha'].itens" :key="item.cod">
                                                        <td data-label="Ud:">
                                                            <span>
                                                                <b>
                                                                    #{{item.id}}
                                                                </b>
                                                            </span>
                                                        </td>

                                                        <td data-label="Nome:">
                                                            <a >
                                                                {{item.objeto.descricao}}
                                                            </a>
                                                        </td>
                                                     
                                                        <td data-label="Select:">
                                                            <code style="font-size: 11px; line-height: 100%;">
                                                                {{item.objeto.query}}
                                                            </code>
                                                        </td>                                                     

                                                        <td data-label="Data/hora:">
                                                            <a >
                                                                {{item.datahora | formatDate}}
                                                            </a>
                                                        </td>   
                                                        <td data-label="Ações:">
                                                            <router-link :to="{'name': 'EditarCampanhasFiltros', 'query': {'c': item.cod}}" class="dashboard-status-button gray">
                                                                <i class="las la-edit"></i>
                                                                Editar
                                                            </router-link>
                                                            <div class="hidden-xs hidden-md" style="height: 5px;"></div>
                                                            <a class="dashboard-status-button gray" v-on:click="delCampanhaFiltro(item.cod)">
                                                                <i class="las la-trash"></i>
                                                                Apagar
                                                            </a>                                                                                                                                                                     
                                                        </td> 
                                                    </tr> 
                                                </tbody>
                                            </table>
                                        </div>
                                        
                                    </div>
                                </div>
                            <!-- </form> -->
                        </div> 

                        <div class="col-xl-12 margin-top-10" v-if="tab == 'honorarios-medicos'">
                            <hr>
                            <form type="post" v-on:submit.prevent="salvar()">
                                <div class="row">
                                    <div class="col-xl-12 margin-bottom-15 margin-top-10">
                                        <h3>
                                            <i class="las la-file-invoice-dollar"></i>
                                            Honorários Médicos
                                        </h3>
                                    </div>
                                    <div class="col-xl-12 col-xs-12 col-lg-12">
                                        <div class="row">

                                            <div class="col-xl-6 col-md-6 col-lg-10">
                                                <div class="submit-field">
                                                    <h5>Link imagem cabeçalho</h5>
                                                    <input type="text" placeholder="..." v-model="form['honorarios-medicos'].objeto.imagemHeader" class="with-border">
                                                </div>
                                            </div>

                                            <div  class="col-xl-6 col-md-6 col-lg-10">
                                                <div class="submit-field">
                                                    <h5>Link imagem rodapé</h5>
                                                    <input type="text" placeholder="..." v-model="form['honorarios-medicos'].objeto.imagemFooter" class="with-border">
                                                </div>
                                            </div>                                            

                                            <div class="col-xl-12 margin-bottom-15">
                                                <div class="submit-field">
                                                    <h5>Texto no final do PDF:</h5>
                                                    <trumbowyg v-model="form['honorarios-medicos'].objeto.textoFinalPDF" :config="config" style="height: 250px !important;" class="" name="textoFinalPDF"></trumbowyg>
                                                </div>
                                            </div>                                          

                                            <div class="col-xl-12 margin-bottom-20">
                                                <button type="submit" class="button green block-mobile">
                                                    <i class="las la-save"></i>
                                                    Salvar alterações
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>    
                        </div>        

                    </div>
                </div>
            </div>
        </div>
        <Toolbar></Toolbar>

    </div>
</template>

<script>
import Top from './Top'
import Toolbar from './Toolbar'
import Sidebar from './Sidebar'

export default {
    name:                           'Configuracoes',
    components: {
        'Trumbowyg':                VueTrumbowyg.default,
        'Top':                      Top,
        'Sidebar':                  Sidebar,
        'Toolbar':                  Toolbar
    },       
    filters: {
        formatDate: function(value) {
            if (!value) {
                return "";
                return false;
            }
            var d = value.split(" ");
            var date = d[0];
            var time = d[1];
            d = date.split("-");
            date = d[2] + "/" + d[1] + "/" + d[0];
            d = time.split(":");
            time = d[0] + ":" + d[1];

            return date + " " + time;
        },
        toMoney: function(value) {
            if (value) {
                return parseFloat(value).toLocaleString('pt-br', {minimumFractionDigits: 2})                
            } else {
                return "0,00";
            }
        },        
    },    
    data () {
        var self                    = this;
        return {
            config: {
                svgPath:            "https://cdnjs.cloudflare.com/ajax/libs/Trumbowyg/2.20.0/ui/icons.svg",
                btns: [
                    ['undo', 'redo'],
                    ['formatting'],
                    ['fontsize'],
                    ['strong', 'em', 'del'],
                    ['link'],
                    // ['insertImage'],
                    ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull'],
                    ['unorderedList', 'orderedList'],
                    ['horizontalRule'],
                    ['removeformat'],
                    // ['fullscreen']
                ]
            },               
            "loaded":               false,
            "tab":                  "",
            "data":                 {
                "itens":            []
            },
            "loading": {
                "submit":           false
            },
            "form": {
                "_cod":             self.$root.user.cod,
                "_token":           self.$root.user.token,  
                "sintomas":         {
                    "objeto": {
                        "habilitado":   1,
                        "pushTitulo": "",
                        "pushTexto": "",
                        "itens": [
                            {
                                "cod":  "",
                                "texto": "",
                                "itens": [
                                    {
                                        "cod":      "",
                                        "texto":    ""
                                    }
                                ]
                            }
                        ]
                    }
                },  
                "lembrete-agendamento":  {
                    "objeto": {
                        "tempo":        0,
                        "pushEnviar":   0,
                        "pushTitulo":   "",
                        "pushTexto":    "",
                        "pushLink":     "",
                        "smsEnviar":    0,
                        "smsTexto":     "",
                        "emailEnviar":  0,
                        "emailTitulo":  "",
                        "emailAssunto": "",
                        "whatsappEnviar":0,
                        "whatsappTexto":"",
                    }
                },
                "confirmacao-agendamento":  {
                    "objeto": {
                        "tempo":        0,
                        "pushEnviar":   0,
                        "pushTitulo":   "",
                        "pushTexto":    "",
                        "pushLink":     "",
                        "smsEnviar":    0,
                        "smsTexto":     "",
                        "emailEnviar":  0,
                        "emailTitulo":  "",
                        "emailAssunto": "",
                        "whatsappEnviar":0,
                        "whatsappTexto":"",
                    }
                },       
                "lembrete-retorno-agendamento":  {
                    "objeto": {
                        "tempo":        0,
                        "pushEnviar":   0,
                        "pushTitulo":   "",
                        "pushTexto":    "",
                        "pushLink":     "",
                        "smsEnviar":    0,
                        "smsTexto":     "",
                        "emailEnviar":  0,
                        "emailTitulo":  "",
                        "emailAssunto": "",
                        "whatsappEnviar":0,
                        "whatsappTexto":"",
                    }
                },                  
                "feedback":  {
                    "objeto": {
                        "tempo":        0,
                        "link":         "",
                        "pushEnviar":   0,
                        "pushTitulo":   "",
                        "pushTexto":    "",
                        "smsEnviar":    0,
                        "smsTexto":     "",
                        "emailEnviar":  0,
                        "emailTitulo":  "",
                        "emailAssunto": "",
                        "whatsappEnviar":0,
                        "whatsappTexto":"",
                    }
                },                       
                "termos-de-uso":            {
                    "objeto": {
                        "conteudo":     ""
                    }
                },
                "politicas-de-privacidade": {
                    "objeto": {
                        "conteudo":     ""
                    }
                },           
                "solicitar-uso-de-dados": {
                    "objeto": {
                        "pushEnviar":   0,
                        "pushTitulo":   "",
                        "pushTexto":    "",
                        "smsEnviar":    0,
                        "smsTexto":     "",
                        "emailEnviar":  0,
                        "emailTitulo":  "",
                        "emailAssunto": "",
                        "whatsappEnviar":0,
                        "whatsappTexto":"",
                    }                    
                },
                "menu": {
                    "objeto": {                   
                        "paciente": {
                            "agendarConsulta":  false,
                            "meusAgendamentos": false,
                            "dicasSemanais":    false,
                            "receitasAtestados":false,
                            "meusExames":       false,
                            "meusDocumentos":   false,
                            "minhaConta":       false,
                            "sair":             false,
                        },
                        "profissional": {
                            "agendarConsulta":  false,
                            "meusAgendamentos": false,
                            "dicasSemanais":    false,
                            "receitasAtestados":false,
                            "honorariosMedicos":false,
                            "meusExames":       false,
                            "meusDocumentos":   false,
                            "minhaConta":       false,
                            "sair":             false,
                        },
                        "marketing": {
                            "agendarConsulta":  false,
                            "meusAgendamentos": false,
                            "dicasSemanais":    false,
                            "receitasAtestados":false,
                            "meusExames":       false,
                            "meusDocumentos":   false,
                            "minhaConta":       false,
                            "sair":             false,
                        },
                        "controladoria": {
                        },
                        "gerente": {
                        },
                        "coordenador": {
                        },                                          
                    }                    
                }, 
                "prontuario": {
                    "objeto": {                   
                        "avaliacoes":   false,
                        "dados":        false,
                        "evolucoes":    false,
                        "ged":          false,
                        "exames":       false,
                    }                    
                },     
                "honorarios-medicos":            {
                    "objeto": {
                        "textoFinalPDF":     ""
                    }
                },                                           
            } 
        }
    },
    watch: {
                  
    },
    methods: {       
        setTab: function(tab, scroll = true) {
            var self        = this;
            console.log("setTab()", tab);
            if (self.tab == tab) return false;

            self.$root.tmp.configuracoes.tab = tab;
            self.$root.$forceUpdate();

            self.tab        = tab;
            loading.show();
            setTimeout(function() {
                $(".dashboard-content-inner")[0].scrollTo({
                    top: 5
                });  
            }, 100);
            self.getItens(scroll);
        },          
        add: function(itens, item) {
            console.log("add()", itens, item);
            var self            = this;
          
            
            item.cod        = md5((new Date()).getTime() + Math.random() + document.cookie + JSON.stringify(itens));
        
            itens.push(JSON.parse(JSON.stringify(item)));


            self.$forceUpdate();
             
        },
        del: function(itens, item) {
            console.log("del()", itens, item);
            var self = this;
            confirm("Você tem certeza que deseja remover este item?", function() {
                var index = itens.indexOf(item);
                itens.splice(index, 1);
                self.$forceUpdate();
            });
        },                      
        getItens: function(scroll = true) {
            var self        = this;
            return new Promise(function(resolve, reject) {

                self.loaded             = false;
                loading.show();

                var form = {
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "nome":         self.tab
                    }
                };

                if (self.tab == "filtro-campanha") {
                    form.params.multiplo = true;
                }

                console.log("getItens()", form);

                axios.get("api/itens.php", form)
                .then(response => {
                    
                    console.log("getItens() response", response);

                    if (self.tab == "menu") {
                        if (!response.data.result.objeto.coordenador) {
                            response.data.result.objeto.coordenador = {};
                        }
                        if (!response.data.result.objeto.controladoria) {
                            response.data.result.objeto.controladoria = {};
                        }
                        if (!response.data.result.objeto.gerente) {
                            response.data.result.objeto.gerente = {};
                        }                                                
                    }

                    if (form.params.multiplo) {
                        self.form[self.tab] = response.data.result; 
                    } else {
                        self.form[response.data.result.nome] = response.data.result; 
                    }

                    self.loaded         = true;
                    self.$forceUpdate();
                    loading.hide();

                    if (scroll) {
                        setTimeout(function() {
                            $(".dashboard-content-inner")[0].scrollTo({
                                top:            $(".scroll-to")[0].getBoundingClientRect().top - 60,
                                behavior:       "smooth"
                            });             
                            // setTimeout(function() {
                            //     loading.hide();
                            // }, 200);
                        }, 200);
                    }

                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("getItens() error", error);                    
                    loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });   
            });   
        },         
        salvar: function() {
            var self            = this;
            var form            = JSON.parse(JSON.stringify(self.form[self.tab]));
            form._cod           = self.$root.user.cod;
            form._token         = self.$root.user.token;
            form.nome           = self.tab;

            console.log("salvar()", form);            

            self.loading.salvar = true;
            loading.show();
            axios.put("api/itens.php", form)
            .then(response => {
                
                self.loading.salvar = false;
                console.log("salvar() response", response)
                loading.hide();

                $(".dashboard-content-inner")[0].scrollTo({
                    top: 5
                });  

                alert(response.data.message);
                
            })
            .catch(error => {
                console.log("salvar() error", error)
                loading.hide();
                self.loading.salvar = false;
                alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
            });

        },  
        delCampanhaFiltro: function(cod) {
            console.log("delCampanhaFiltro()", cod);
            var self                = this;
            confirm("Você tem certeza que deseja apagar esse item?", function() {

                var form = {
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "cod":          cod
                    }
                };

                loading.show();
                
                axios.delete("api/campanhas-filtros.php", form)
                .then(response => {
                    console.log("delCampanhaFiltro() response", response)
                    self.getItens();
                    alert(response.data.message);
                })
                .catch(error => {
                    console.log("delCampanhaFiltro() error", error)
                    loading.hide();
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });
            });
        }    
    },
    created: function() {
        var self = this;

        if (self.$root.tmp.configuracoes.tab && self.tab != self.$root.tmp.configuracoes.tab) {
            self.setTab(self.$root.tmp.configuracoes.tab, false);     
        } else {
            self.setTab("lembrete-agendamento", false);     
        }


    },
    mounted: function() {
        var self = this;
        
    },
    activated: function() {
        var self = this;
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    hr {
        opacity: 0.2;
    }
    h3 i {
        color: #00995d;
    }   
    .button.block-mobile.small {
        border: 2px solid #00995d;
    }
    .trumbowyg-editor {
        height: 500px !important;
    }
    textarea[name="politicasPrivacidade"] {
        display: none !important;
    }
    textarea[name="termosUso"] {
        display: none !important;
    }    
    .menu .button {
        margin-bottom: 0px;
        margin-right: 3px;
    }

    @media only screen and (max-width: 736px) { 
        .menu .button:not(:last-child) {
            border-bottom: 0px !important;
        }
        .menu .button {
            margin-right: 0px !important;
            border-top-right-radius: 0px;
            border-top-left-radius: 0px;
            border-bottom-right-radius: 0px;
            border-bottom-left-radius: 0px;
        }
        .menu .button:first-child {
            border-top-right-radius: 6px !important;
            border-top-left-radius: 6px !important;
        }        
        .menu .button:last-child {
            border-bottom-right-radius: 6px !important;
            border-bottom-left-radius: 6px !important;
        }                
    }
</style>



// WEBPACK FOOTER //
// src/components/Configuracoes.vue